export default "__VITE_ASSET__DnjD8LQQ__"